import { render, staticRenderFns } from "./MaterialUploadImage.vue?vue&type=template&id=9818d634"
import script from "./MaterialUploadImage.vue?vue&type=script&lang=js"
export * from "./MaterialUploadImage.vue?vue&type=script&lang=js"
import style0 from "./MaterialUploadImage.vue?vue&type=style&index=0&id=9818d634&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_875f195a559ab6cb5ed9ea4190ad0331/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports